import {
    createApiQueryHook,
    IApiQueryFunction,
    IOrderable,
    IPaginateable,
    mapOrder,
    mapPagination,
} from "../../utils/api";
import { serialize } from "../../utils/url";
import { BrandStatus } from "../types/IBrand";
import { IBrandList } from "../types/IBrandList";

export type IBrandListQueryParameters = IPaginateable &
    IOrderable<
        "title" | "domainUi" | "status" | "contentVisibility" | "contentProtectedViewable" | "createdAt" | "updatedAt"
    > & {
        filters?: {
            status?: BrandStatus;
        };
    };

export type IBrandListQueryResult = IBrandList;

const mapFilters = (filters: IBrandListQueryParameters["filters"]) => ({
    status: filters?.status,
});

export const brandListQuery: IApiQueryFunction<IBrandListQueryParameters> = ({ pagination, filters, order }) => {
    return {
        method: "GET",
        url: `/brands${serialize({ ...mapPagination(pagination), ...mapOrder(order), ...mapFilters(filters) }, true)}`,
    };
};

export const useBrandListQuery = createApiQueryHook<IBrandListQueryParameters, IBrandListQueryResult>(brandListQuery);
